import groupBy from "lodash/groupBy"
import orderBy from "lodash/orderBy"

import { PlatformRow } from "@/components/company/platform-row"
import { PLATFORMS_WITH_REVIEWS } from "@/constants/platform/data-by-platform"
import type { Platform } from "@/constants/platform/platform"
import { cn } from "@/lib/utils"

export function PlatformList({
  sources,
  reviewCountByPlatform,
  className,
}: {
  sources: {
    platform?: string
    reviewSummary: {
      averageRating: number | null
      reviewCount: number | null
    } | null
  }[]
  reviewCountByPlatform: Record<string, number>
  className?: string
}) {
  const sourcesByPlatform = groupBy(
    sources.filter((s) => s.platform),
    "platform"
  )
  const platformData = []
  for (const platform of PLATFORMS_WITH_REVIEWS) {
    const platformSources = sourcesByPlatform[platform] ?? []
    const reviewCount = reviewCountByPlatform[platform] ?? 0

    let weightedSum = 0
    let profileReviewTotal = 0
    for (const source of platformSources) {
      const summary = source.reviewSummary
      if (!summary?.averageRating || !summary.reviewCount) continue
      profileReviewTotal += summary.reviewCount
      weightedSum += summary.averageRating * summary.reviewCount
    }

    platformData.push({
      platform: platform as Platform,
      locationCount: platformSources.length,
      reviewCount,
      rating: profileReviewTotal > 0 ? weightedSum / profileReviewTotal : null,
    })
  }

  const sortedPlatformData = orderBy(platformData, "reviewCount", "desc")

  return (
    <div className={cn("divide-muted-foreground divide-y", className)}>
      {sortedPlatformData.map((p) => (
        <PlatformRow key={p.platform} {...p} />
      ))}
    </div>
  )
}
